import type {ManifestationStatus} from 'services/metadata/types';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditStatuses} from '../metadataEditSlice';

export const useAggregatedStatus = (id: string): ManifestationStatus => {
  return useAppSelector(selectMetadataEditStatuses)[id]?.status ?? 'NEW';
};
